import type { HelpFile } from '../../types/help'
import { ScimConfigCardTestIds } from '../../../testids/ScimConfigCardTestIds'

export const scimConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ScimConfigCardTestIds.cardTitleScimConfig]: 'SCIM-Konnektor-Konfiguration — Endpunkt-URL, Zugangsdaten und Patch-Verhalten.',
    [ScimConfigCardTestIds.btnCreateScimConfig]: null,
    [ScimConfigCardTestIds.btnEditScimConfig]: null,
    [ScimConfigCardTestIds.selectPatchStyle]: 'Wie der Konnektor Aktualisierungen anwendet: vollständiges Ersetzen oder RFC-7644-Patch-Operationen.',
  },
}
